import api from 'Application/api/api';

const createProjectDeveloper = (signal, values) =>
	api.post('/project-developers', values, {
		signal,
	});

export default createProjectDeveloper;
